import { writable, get } from 'svelte/store';

/**
 * Creates a guarded async action that prevents concurrent execution
 * and exposes a reactive loading store for buttons.
 */
export function createAsyncAction() {
	const loading = writable(false);

	return {
		loading,
		async run<T>(fn: () => Promise<T>): Promise<T | undefined> {
			if (get(loading)) return undefined;
			loading.set(true);
			try {
				return await fn();
			} finally {
				loading.set(false);
			}
		},
	};
}

export type AsyncAction = ReturnType<typeof createAsyncAction>;
